import script from "./project-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./project-report-table.vue?vue&type=script&setup=true&lang=js"

import "./project-report-table.vue?vue&type=style&index=0&id=8bcc910e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bcc910e"]])

export default __exports__